import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { getThumbUrl } from '@/utils/imageUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'CUserAvatar',
  props: {
    name: null,
    picturePath: null,
    size: { default: 40 },
    circle: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { name?: string, picturePath?: string, size: number, circle?: boolean };



const initials = computed(() => props.name?.toUpperCase().slice(0, 2) ?? '');

const pictureUrl = computed(() => (props.picturePath ? getThumbUrl(props.picturePath) : undefined));

const avatarStyle = computed(() => ({
    width: `${props.size}px`,
    height: `${props.size}px`,
    fontSize: `${props.size * 0.5}px`
}));

return { __sfc: true,props, initials, pictureUrl, avatarStyle }
}

})